import {
	request,
	uploadService,
	trainingServe,
	aiService,
	assessmentUrl,
} from "@/utils/request";

//get all categories
const dragAndDropSection = (data) => {
	return trainingServe({
		url: "/course/lesson-controller/",
		method: "patch",
		data,
	});
};
const savePricingDetails = (data, method = "get") => {
	const config = {
		url: "/course/payment-controller/",
		method,
	};

	if (method.toLowerCase() === "get") {
		config.params = data;
	} else {
		config.data = data;
	}

	return trainingServe(config);
};

const getCategories = () => {
	return request({
		url: "/hire3x/categories/",
		method: "get",
		params: {
			count: "all",
			searchQuery: "",
			dropdown: true,
		},
	});
};

//get all subcategories
const getSubCategories = (data) => {
	return request({
		url: "/hire3x/categories/",
		method: "get",
		params: {
			count: "all",
			searchQuery: "",
			categoryID: data.categoryID,
			dropdown: true,
		},
	});
};

//create course
const createCourse = (data) => {
	return request({
		url: "/course/course-controller/",
		method: "post",
		data,
	});
};

const getCourseData = (
	courseID,
	version = "",
	isContentRequired = "",
	current = ""
) => {
	return request({
		url: `/course/course-controller?courseID=${courseID}&version=${version}&isContentRequired=${isContentRequired}&current=${current}`,
		method: "get",
	});
};

const getLessonData = (lessonID, isContentRequired = true) => {
	return request({
		url: `course/lesson-controller/?lessonID=${lessonID}&isContentRequired=${isContentRequired}`,
		method: "get",
	});
};
const getLessonDetails = (lessonID, isContentRequired = false) => {
	return request({
		url: `course/lesson-controller/?lessonID=${lessonID}&isContentRequired=${isContentRequired}`,
		method: "get",
	});
};
const getSections = (courseID, isContentRequired = true) => {
	return request({
		url: `/course/section-controller?courseID=${courseID}&isContentRequired=${isContentRequired}`,
		method: "get",
	});
};

const sectionApi = (data, method) => {
	return request({
		url: "/course/section-controller/",
		method,
		data,
	});
};
const addQuiz = (data) => {
	return request({
		url: "/course/lesson-controller/",
		method: "post",
		data,
	});
};

const deleteLesson = (data) => {
	return request({
		url: `/course/lesson-controller/`,
		method: "delete",
		data,
	});
};
const addQuestion = (data) => {
	return request({
		url: "/quiz/question/",
		method: "post",
		data,
	});
};
const addFromDataBank = (data) => {
	return request({
		url: "/quiz/quiz-controller/",
		method: "put",
		data,
	});
};
const deleteFromQuiz = (data) => {
	return request({
		url: "/quiz/quiz-controller/",
		method: "delete",
		data,
	});
};
const getBucket = (data) => {
	return request({
		url: "/repository/asset-management/",
		method: "patch",
		data,
	});
};

const checkFileExists = (data) => {
	return uploadService({
		url: "/file",
		method: "post",
		data,
	});
};

const createLesson = (data, method = "post") => {
	return request({
		url: "/course/lesson-controller/",
		method,
		data,
	});
};
const getCourseRatings = (data) => {
	return request({
		url: "/marketplace/rating/",
		method: "get",
		params: {
			referenceID: data.referenceID,
			getSummaryInfo: data.getSummaryInfo,
			count: data.count,
			page: data.page,
			reported: data.reported,
		},
	});
};

//get all sections with content
const getAllSectionsWithContent = (data) => {
	return request({
		url: "/course/section-controller/",
		method: "get",
		params: {
			courseID: data.courseID,
			isContentRequired: data.isContentRequired,
			isLessonRequired: data.isLessonRequired,
		},
	});
};

//put course info
const putCourseInfo = (data) => {
	return request({
		url: "/course/course-controller/",
		method: "put",
		data,
	});
};

const updateCourseAsset = (data) => {
	return request({
		url: "/course/course-controller/",
		method: "patch",
		data,
	});
};

// get course counts
const getCourseCounts = (courseID, version = "", admin = true) => {
	return request({
		url: `common/course-counts/?courseID=${courseID}&version=${version}&admin=${admin}`,
		method: "get",
	});
};

const getResourceContent = (sectionID) => {
	return request({
		url:
			"course/lesson-controller/?sectionID=" +
			sectionID +
			"&isContentRequired=true&lessonType=3",
		method: "get",
	});
};

const setItem = (data, method = "POST") => {
	return request({
		url: "/course/payment-controller/",
		method,
		data,
	});
};

const courseApproval = (data) => {
	return request({
		url: "/hire3x/course-approval/",
		method: "post",
		data,
	});
};

const getLanguages = (data) => {
	return request({
		url: `hire3x/language-controller/`,
		method: "get",
		params: data,
	});
};

const writeWithHire3xAI = (data) => {
	return aiService({
		url: "ai/course-information/",
		method: "post",
		data,
	});
};

const getTagSuggestions = (data) => {
	return request({
		url: "course/tag-suggestions/",
		method: "get",
		params: data,
	});
};

const setCourseState = (data) => {
	return request({
		url: "/course/course-controller/",
		method: "put",
		data,
	});
};

const getConfigs = (data) => {
	return request({
		url: "course/config-controller/",
		method: "get",
		params: data,
	});
};

const addConfig = (data) => {
	return request({
		url: "course/config-controller/",
		method: "post",
		data,
	});
};

const updateConfig = (data) => {
	return request({
		url: "course/config-controller/",
		method: "put",
		data,
	});
};

const deleteConfig = (data) => {
	return request({
		url: "course/config-controller/",
		method: "delete",
		data,
	});
};

const patchConfig = (data) => {
	return request({
		url: "course/config-controller/",
		method: "patch",
		data,
	});
};

const addliveClass = (data, method = "post") => {
	const config = {
		url: "/course/lesson-controller/",
		method,
	};

	if (method.toLowerCase() === "get") {
		config.params = data;
	} else {
		config.data = data;
	}

	return request(config);
};

const getTopics = (data) => {
	return assessmentUrl({
		url: "/lis/jd-topic-list/",
		method: "get",
		params: data,
	});
};

const getTest = (data) => {
	return assessmentUrl({
		url: "/lis/jd-test-list/",
		method: "get",
		params: data,
	});
};

const getAssessment = (data) => {
	return assessmentUrl({
		url: "/lis/test-info/",
		method: "get",
		params: data,
	});
};

const takeAssessment = (data) => {
	return assessmentUrl({
		url: "/can/v2/share-link-training/",
		method: "post",
		data,
	});
};

const createConfig = (data, method = "post") => {
	return assessmentUrl({
		url: "/share/v2/config/",
		method,
		data,
	});
};

const createTest = (data) => {
	return assessmentUrl({
		url: "can/v2/tag-tests-training/",
		method: "post",
		data,
	});
};

const showCourseHistory = (courseID) => {
	return trainingServe({
		url: `/course/course-history/?courseID=${courseID}`,
		method: "get",
	});
};

const pricingDetails = (courseID, logID) => {
	return trainingServe({
		url: `/course/course-history/?courseID=${courseID}&logID=${logID}`,
		method: "get",
	});
};
// const addAssessment = (data, method = "post") => {
// 	const config = {
// 		url: "/course/lesson-controller/",
// 		method,
// 	};

// 	if (method.toLowerCase() === "get") {
// 		config.params = data;
// 	return request(config);
// };

const getVersions = (courseID) => {
	return request({
		url: `/hire3x/get-courses-version-list/?courseID=${courseID}`,
		method: "get",
	});
};

const dosanddontslist = () => {
	return assessmentUrl({
		url: `proctoring/codeList`,
		method: "get",
	});
};

export {
	getCategories,
	getSubCategories,
	createCourse,
	getCourseData,
	getSections,
	sectionApi,
	getBucket,
	checkFileExists,
	createLesson,
	addQuiz,
	addQuestion,
	getLessonData,
	addFromDataBank,
	deleteFromQuiz,
	getCourseRatings,
	getAllSectionsWithContent,
	deleteLesson,
	getLessonDetails,
	putCourseInfo,
	updateCourseAsset,
	getCourseCounts,
	getResourceContent,
	setItem,
	courseApproval,
	getLanguages,
	savePricingDetails,
	dragAndDropSection,
	writeWithHire3xAI,
	getTagSuggestions,
	setCourseState,
	getConfigs,
	addConfig,
	updateConfig,
	deleteConfig,
	patchConfig,
	addliveClass,
	getTopics,
	getTest,
	createConfig,
	createTest,
	getAssessment,
	takeAssessment,
	showCourseHistory,
	pricingDetails,
	getVersions,
	dosanddontslist
};
